import classNames from 'classnames'
import React, { useEffect, useRef, useState } from 'react'
// import { useBottomScrollListener } from 'react-bottom-scroll-listener'
import Scrollbar from 'react-scrollbars-custom'
import useResizeObserver from 'use-resize-observer'

type MainContentProps = {
  className?: string
  onScrolledToEnd?: () => void
  children: React.ReactNode
}

const MainContent: React.FC<MainContentProps> = ({
  className,
  children,
  onScrolledToEnd,
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const { height = 1 } = useResizeObserver<HTMLDivElement>({ ref })

  const [topBorder, setTopBorder] = useState(false)
  const [bottomBorder, setBottomBorder] = useState(false)

  const topBorderRef = useRef(topBorder)
  const bottomBorderRef = useRef(bottomBorder)
  topBorderRef.current = topBorder
  bottomBorderRef.current = bottomBorder

  useEffect(() => {
    if (ref.current) {
      document.documentElement.style.setProperty('--main-height', `${height}px`)
    }
  }, [height])

  const scrollerRef = useRef<HTMLDivElement>()

  return (
    <div
      className={classNames('main-content', className, {
        'is-topBorder': topBorder,
        'is-bottomBorder': bottomBorder,
      })}
      ref={ref}
    >
      <Scrollbar
        disableTracksWidthCompensation={true}
        elementRef={r => {
          if (r) {
            scrollerRef.current = r.querySelector(
              '.ScrollbarsCustom-Scroller'
            ) as HTMLDivElement
          }
        }}
        onUpdate={state => {
          if (state.scrollTop) {
            if (!topBorderRef.current) {
              setTopBorder(true)
            }
          } else {
            if (topBorderRef.current) {
              setTopBorder(false)
            }
          }

          if (state.scrollYPossible) {
            if (
              state.clientHeight + state.scrollTop >=
              state.contentScrollHeight
            ) {
              if (bottomBorderRef.current) {
                onScrolledToEnd && onScrolledToEnd()
                setBottomBorder(false)
              }
            } else {
              if (!bottomBorderRef.current) {
                setBottomBorder(true)
              }
            }
          } else {
            if (bottomBorderRef.current) {
              setBottomBorder(false)
            }
          }
        }}
      >
        {children}
      </Scrollbar>
    </div>
  )
}

export default MainContent
